<template>
    <b-modal title="Water Bill"  no-close-on-backdrop hide-footer size="xl" v-model="largeModal" @ok="largeModal = false">
        <form>
            <div class="form-group row">
               <div style="margin:0 auto" id="invoice">
                    <div class="toolbar hidden-print">
                        <div class="text-right">
                            <button @click.prevent="printInvoice()"  class="btn btn-info"><i class="fa fa-print"></i>Print</button>
                            <!-- <button @click.prevent="print"  class="btn btn-info"><i class="fa fa-print"></i>Download</button> -->
                        </div>
                        <hr>
                    </div>
                    <div id="printMe" class="invoice container">
                        <div>
                            <div class="row">
                                <div class="left_side col-md-4">বিল নং</div><div class="left_side col-md-8">:{{invoice.bill_no}}</div>
                                <div class="left_side col-md-4">ইস্যুর তারিখ</div><div class="left_side col-md-8">:{{invoice.issue_date}}</div>
                                <div class="left_side col-md-4">পরিশোধের শেষ তারিখ</div><div class="left_side col-md-8">:{{invoice.last_date}}</div>
                                <div class="left_side col-md-4">বিলের মাস ও বছর</div><div class="left_side col-md-8">:{{invoice.bill_month_year}}</div>
                                <br><br>
                                <div class="left_side col-md-4">হিসাব নং</div><div class="left_side col-md-8">:{{invoice.account_no}}</div>
                                <div class="left_side col-md-4">গ্রাহক আইডি</div><div class="left_side col-md-8">:{{invoice.account_no}}</div>
                                <div class="left_side col-md-4">গ্রাহকের নাম</div><div class="left_side col-md-8">:{{invoice.customer}}</div>
                                <div class="left_side col-md-4">পিতা/স্বামী/প্রতিষ্ঠান নাম</div><div class="left_side col-md-8">:{{invoice.husband_wife}}</div>
                                <div class="left_side col-md-4">রাস্তা/এলাকা/মোল্লা/মৌজা</div><div class="left_side col-md-8">:{{invoice.moholla_name}}</div>
                                <div class="left_side col-md-4">গ্রাহকের ঠিকানা</div><div class="left_side col-md-8">:{{invoice.address}}</div>
                                <div class="left_side col-md-4">ওয়ার্ড নং</div><div class="left_side col-md-8">:{{invoice.ward_no_old}}{{invoice.ward_no}}</div>
                                <div class="left_side col-md-4">গ্রাহকের ধরন</div><div class="left_side col-md-8">: <span v-if="invoice.service">{{invoice.service.name}}</span></div>
                                <div class="left_side col-md-4">সংযোগের ব্যাস</div><div class="left_side col-md-8"><span v-if="invoice.service">:{{invoice.service.diameter}} inch</span></div>
                                <br><br>
                                <div class="left_side col-md-4">মাসিক পানির বিল</div><div class="left_side col-md-8">:<span v-if="invoice.personal_note != 'new-water-connection'">{{invoice.amount}}</span></div>
                                <div class="left_side col-md-4">সংযোগ/পুনঃসংযোগ ফি</div><div class="left_side col-md-8">:<span v-if="invoice.personal_note == 'new-water-connection'">{{invoice.amount}}</span></div>
                                <div class="left_side col-md-4">মালামাল সরবরাহ ফি</div><div class="left_side col-md-8">:{{invoice.goods_fee}}</div>
                                <div class="left_side col-md-4">বিবিধ</div><div class="left_side col-md-8">:{{invoice.others_fee}}</div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="left_side col-md-8">বকেয়া</div><div class="left_side col-md-4">:{{invoice.due_ammount}}</div>
                                        <div class="left_side col-md-8">সারচার্জ</div><div class="left_side col-md-4">:{{invoice.due_charge}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="left_side col-md-8">বকেয়া শুরুর মাস</div><div class="left_side col-md-4">:{{invoice.due_month}}</div>
                                        <div class="left_side col-md-8">বকেয়া শুরুর বছর</div><div class="left_side col-md-4">:{{invoice.due_year}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="left_side col-md-4">সর্বমোট</div><div class="left_side col-md-8">:{{invoice.total}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
const options = {
  name: '_blank',
  specs: [
    // 'fullscreen=yes',
    // 'titlebar=yes',
    // 'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper,options);
import axios from 'axios'
import domtoimage from 'dom-to-image'
import { mapState,mapGetters } from "vuex"
export default {
    data(){
        return{
            largeModal:false,
            invoice:'',
            projects:[],
            month:['','January','February','March','April','May','June','July','August','September','October','November','December']
        }
    },
    methods:{
        printInvoice() {
            this.$htmlToPaper('printMe');
            // alert("ok");
        },
        openModal(invoice){
            // alert("ok");
            this.largeModal = true
            this.invoice = invoice
            // this.allProjects()
            // this.customerVisa(invoice.customer_id)
        },
        allProjects(){
            return new Promise((resolve, reject) => {
                axios.get("api/project-all")
                .then(response => {
                    this.projects = response.data
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        print(){
            // var printContents = document.getElementById("ttest").innerHTML;
            // var originalContents = document.body.innerHTML;
			// document.body.innerHTML =  printContents;
			// window.print();
            // document.body.innerHTML = originalContents;
            var invoice_number = this.invoice.invoice_number
            domtoimage.toJpeg(document.getElementById('print-div'), { quality: 0.95 })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = invoice_number+'.jpeg';
                link.href = dataUrl;
                link.click();
            });
        },
        close(){
            this.largeModal = false
        }
        ,
        customerVisa(id){
            this.customerVisaLoading=true;
            this.$store.dispatch('CUSTOMER_VISA',id)
            .then(response=>{
               this.customerVisaLoading=false; 
            })
            .catch(error=>{
               this.customerVisaLoading=false;       
            });
        },
    },
    computed:{
        ...mapGetters(["customervisas"])
    }

}
</script>




<style>
.left_side{
    width:15%;
    text-align:left
}
.right_side{
    width:85%;
    text-align:left
}
</style>
